export default __webpack_public_path__ + "static/media/cuisine.7e74446f.png";